import styled from "styled-components";
import { ContentContainer } from "../../ui/display/ContentContainer";
import { useEffect, useRef, useState } from "react";
import { Datepicker } from "../../ui/inputs/Datepicker";
import { formatDateWithMonthAbbr, formatLocalDate } from "utilities/dateAndTime";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";


export const ProjectPathUpdate = ({update, onEdit, onRemove}) => {

    const [isProjectUpdateEdit, setIsProjectUpdateEdit] = useState(false);
    const [projectUpdateEdit, setProjectUpdateEdit] = useState(update);

    return (
        <StyledProjectPathUpdate
            contentOrientation="row"
            contentGap="md"
            paddingLeft='lg'
            paddingRight='lg'
            paddingTop='md'
            paddingBottom='md'
        >
            <div>
                <DatepickerWindow
                    date={update.date}
                    onChange={(e) => {
                        const updated = {
                            ...projectUpdateEdit,
                            date: formatLocalDate(e)
                        };

                        setProjectUpdateEdit(updated);
                        onEdit(updated);
                    }}
                />
            </div>
            <div className="updateTitle">
                {
                    isProjectUpdateEdit
                    ? <input
                        placeholder="Beskriv oppdateringen"
                        value={projectUpdateEdit.description}
                        onChange={(e) => setProjectUpdateEdit(prev => ({...prev, description: e.target.value}))}
                    />
                    : <div> {update.description} </div>
                }
            </div>
            <div className="updateEditContainer">
                {
                    isProjectUpdateEdit
                    ? <MaterialIcon
                        name="check"
                        weight={300}
                        onClick={() => {
                            if(projectUpdateEdit.description.length < 5) return;
                            onEdit(projectUpdateEdit);
                            setIsProjectUpdateEdit(false);
                        }}
                    />
                    : <>
                        <MaterialIcon
                            name="inventory_2"
                            weight={300}
                            color={({theme}) => theme.colors.errorForeground}
                            onClick={() => onRemove(projectUpdateEdit)}
                        />
                        <MaterialIcon
                            name='edit'
                            weight={300}
                            color={({theme}) => theme.colors.mutedForeground}
                            onClick={() => setIsProjectUpdateEdit(true)}
                        />
                    </>
                }
            </div>
        </StyledProjectPathUpdate>
    )
}

const StyledProjectPathUpdate = styled(ContentContainer)`

    align-items: center;
    transition-duration: 110ms;

    div.updateTitle
    {
        flex: 1;

        > div
        {
            width: 100%;
            padding: ${({theme}) => theme.spacing.sm} ${({theme}) => theme.spacing.md};
        }

        > input
        {
            padding: ${({theme}) => theme.spacing.sm} ${({theme}) => theme.spacing.md};
            font-size: ${({theme}) => theme.fontSize.md};
            border: none;
            outline: none;
            width: 100%;
        }
    }

    div.updateEditContainer
    {
        display: flex;
        gap: ${({theme}) => theme.spacing.sm};
        opacity: 0;
        transition-duration: 110ms;

        .icon
        {
            cursor: pointer;
            font-size: ${({theme}) => theme.iconSize.sm};
        }
    }

    &:hover div.updateEditContainer
    {
        opacity: 1;
    }
    
    &:has(input)
    {
        border: 1px solid ${({theme}) => theme.colors.neutralSecondaryForeground};

        div.updateEditContainer
        {
            opacity: 1;
        }
    }
`

const DatepickerWindow = ({date, onChange}) => {

    const [isDatePickerOpen, setDatePickerOpen] = useState(false);

    const ref = useRef();
    const buttonRef = useRef();

    useEffect(() => {
        const clickHandler = (e) => {
            const el = ref.current;
            const elButton = buttonRef.current;
            if(!e.target || !el || !elButton) return;

            if(!el.contains(e.target) && !elButton.contains(e.target)) setDatePickerOpen(false)
        }

        document.addEventListener("click", clickHandler);

        return () => {document.removeEventListener("click", clickHandler);}
    }, [])

    return (
        <StyledDatepickerWindow>
            <div
                ref={buttonRef}
                onClick={() => setDatePickerOpen(prev => !prev)}
                className="updateDateContainer"
            >
                {formatDateWithMonthAbbr(new Date(date))}
            </div>
            {
                isDatePickerOpen ?
                <div ref={ref} className="floatingDatepicker">
                    <Datepicker
                        date={date}
                        onChange={(e) => {
                            onChange(e);
                            setDatePickerOpen(false);
                        }}
                    />
                </div>
                : null
            }
            
        </StyledDatepickerWindow>
    )
}

const StyledDatepickerWindow = styled.div`
    position: relative;
    user-select: none;

    div.updateDateContainer
    {
        font-size: ${({theme}) => theme.fontSize.sm};
        background: ${({theme}) => theme.colors.neutralSecondaryBackground};
        border-radius: ${({theme}) => theme.cornerRadius.sm};
        padding: ${({theme}) => theme.spacing.sm} ${({theme}) => theme.spacing.md};
        cursor: pointer;
        width: 115px;
        text-align: center;
        flex: 0 0 115px;
    }

    div.floatingDatepicker
    {
        position: absolute;
        z-index: 1000;
        top: 0;
        right: -${({theme}) => theme.spacing.md};

        transform: translateX(100%);
        border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        padding: ${({theme}) => theme.spacing.md};
        background: ${({theme}) => theme.colors.neutralSecondaryBackground};
        border-radius: ${({theme}) => theme.cornerRadius.md};
        filter: drop-shadow(0 2px 2px rgba(${({theme}) => theme.colors.neutralSecondaryForegroundRGB }, 0.35));
    
    }
`